import styled from "@emotion/styled";
import { FC } from "react";

import { Button, ButtonProps } from "@livechat/design-system-react-components";

interface IProps {
  href: string;
  onClick?: () => void;
  className?: string;
  size?: ButtonProps["size"];
}

export const Context2025PromoLinkButton: FC<IProps> = ({ href, onClick, className, size }) => (
  <StyledButton
    href={href}
    target="_blank"
    rel="nofollow noreferrer noopener"
    onClick={onClick}
    className={className}
    size={size}
  >
    Save the date
  </StyledButton>
);

const StyledButton = styled(Button)`
  border-radius: 840px;
  border: 2px solid rgba(218, 255, 175, 0.4);
  background: radial-gradient(41.29% 41.29% at 52.53% -0.36%, #f5ffe5 0.47%, #daffaf 100%);
  box-shadow:
    0 4.208px 15.989px 1.683px rgba(15, 29, 24, 0.1),
    0 -1.231px 3.694px 0 rgba(15, 29, 24, 0.2) inset;
  color: #000;

  * {
    font-family: Fustat, sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 115%;
    color: #0f1d18;
    ${({ size }): string => (size === "compact" ? "font-size: 14px;" : "")}
  }

  &:hover {
    border: 2px solid rgba(218, 255, 175, 0.4);
    opacity: 0.9;
  }
`;
